import { render, staticRenderFns } from "./GroupNav.vue?vue&type=template&id=a7afb3a6&scoped=true&"
import script from "./GroupNav.vue?vue&type=script&lang=js&"
export * from "./GroupNav.vue?vue&type=script&lang=js&"
import style0 from "./GroupNav.vue?vue&type=style&index=0&id=a7afb3a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7afb3a6",
  null
  
)

export default component.exports